var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__a",
    width: 59,
    height: 59,
    x: 0,
    y: 0,
    rx: 29.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    width: 59,
    height: 59,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    x: 6.9,
    y: 6.9,
    fill: "#587E85",
    fillRule: "nonzero",
    rx: 22.5
  }), /*#__PURE__*/React.createElement("use", {
    fillRule: "nonzero",
    stroke: "#587E85",
    strokeDasharray: 2,
    strokeWidth: 1.438,
    mask: "url(#prefix__b)",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#587E85",
    strokeWidth: 0.9,
    d: "M36.227 29.027c0 .993-.807 1.8-1.8 1.8h-3.6v3.6c0 .993-.807 1.8-1.8 1.8-.994 0-1.8-.807-1.8-1.8v-3.6h-3.6c-.994 0-1.8-.807-1.8-1.8 0-.994.806-1.8 1.8-1.8h3.6v-3.6c0-.994.806-1.8 1.8-1.8.993 0 1.8.806 1.8 1.8v3.6h3.6c.993 0 1.8.806 1.8 1.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.bd68f23f4071274e92a161712a9c7829.svg";
export { ForwardRef as ReactComponent };